import '../styles/Quotes.css'
import { columnsQuotes, columnsQuotesAdmin, columnsEmployeesAdmin } from '../Component/Hooks/ColumTables'
import Table from '../Component/Tabla/Tabla'
import { useContext, useEffect, useState } from 'react'
import LoginContext from '../Context/Logincontext';
import { urlApiServer } from '../Config/Config'
import Loader from '../Component/Loader';
import EditEmployee from '../Component/Hooks/EditEmployee';

const Employees = () => {

    const urlGetClient = urlApiServer + "historyproduct"
    const urlgetEmployees = urlApiServer + "getemployees"
    const urlgetConfig = urlApiServer + "getConfig";
    const urlGetRemission = urlApiServer + "getRemission"
    const urlGetCompany = urlApiServer + "company"

    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [employeesGetTable, setEmployeesGetTable] = useState([])
    const [filterTable, setFilterTable] = useState([])
    const [state, setState] = useState("0")
    const [powerEdit, setPowerEdit] = useState(true)
    const [powerandoff, setPowerandoff] = useState(true)
    const [id, setId] = useState()
    const [oldConfig, setOldConfig] = useState("")
    const [dataRemission, setDateRemission] = useState([])
    const [company, setCompany] = useState([])
    const [disabledBottom, setDisabledBottom] = useState(false);
    const [modify, setModify] = useState({})


    useEffect(() => {
        (async function () {

            if (infoUser.login !== true) {
                window.location.href = './Login'
            }

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }
            await fetch(urlgetConfig, requesoption).then(response => response.json()).then(quotesResponse => {
                setOldConfig(quotesResponse)
            })
        }())


    }, [])



    useEffect(() => {
        (async function () {
            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json");
            InicioHeaders.append("company", infoUser.company); // Enviar el nombre de la empresa como encabezado

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            };

            await fetch(urlgetEmployees, requesoption)
                .then(response => response.json())
                .then(quotesResponse => {
                    setEmployeesGetTable(quotesResponse.reverse());
                })
                .catch(error => {
                });

            const InicioHeaders2 = new Headers();
            InicioHeaders2.append("Content-Type", "application/json");
            InicioHeaders2.append("company", infoUser.company); // Enviar el nombre de la empresa como encabezado

            const requesoption2 = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            };

        }())

    }, [state, urlGetClient, urlgetEmployees, powerEdit])

    useEffect(() => {
    }, [filterTable])

    useEffect(() => {
        if (disabledBottom) {
            if (powerandoff === true) {
                setPowerandoff(false)
            } else {
                setPowerandoff(true)
            }
        }
    }, [disabledBottom])

    async function handleModify(e) {
        setModify(e)
    }

    async function edit() {
        if (powerEdit === true) {
            setPowerEdit(false)
        } else {
            setPowerEdit(true)
        }
    }

    async function handleId(e) {
        setId(e)
    }

    return (
        <>
            {
                (infoUser.companyType === "Marmol") && (
                    (disabledBottom) && (
                        <div className="backgroundLoader">
                            <Loader />
                        </div>
                    )
                )
            }
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    (powerEdit === true) ? (
                        <>
                            {(infoUser.role === 'Administrador') ? (
                                <>

                                    <Table columns={columnsEmployeesAdmin} data={employeesGetTable} handleModify={handleModify} edit={edit} id={handleId} />
                                </>
                            ) : (
                                <>
                                    <Table columns={columnsQuotes} data={employeesGetTable} />
                                </>
                            )}
                        </>
                    ) : (
                        (<EditEmployee id={id} data={modify} edit={edit} />)
                    )
                )
            ) : (<></>)}
        </>
    )
}

export default Employees